var render = function render(){var _vm=this,_c=_vm._self._c;return _c('owal-panel',{attrs:{"title":_vm.title,"content":_vm.content},on:{"change":_vm.inputChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }